import React from 'react';
import ReportAdLayout, { MobileReportAd } from '../components/ReportAdLayout';

export default function PrivacyPolicyPage() {
  return (
    <div style={{ minHeight: '100vh' }}>
      <header className="lb-header">
        <div className="lb-header-inner">
          <a className="lb-logo" href="/">☕ 라떼비버</a>
          <span style={{ color: 'var(--color-text-muted)', fontSize: '14px', fontWeight: 600 }}>
            은퇴 연금 리포트
          </span>
        </div>
      </header>

      <ReportAdLayout>
        <div className="lb-section-sm">
          <div className="lb-container" style={{ maxWidth: '760px' }}>
            <div className="lb-card lb-card-padded">

              <h1 className="lb-title-md" style={{ marginBottom: '4px' }}>개인정보처리방침</h1>
              <p className="lb-text-muted lb-text-sm" style={{ marginBottom: '18px' }}>
                시행일: 2026년 5월 1일 · 버전 v1.0
              </p>

              <MobileReportAd className="report-policy-mobile-ad" />

            <p style={{ marginBottom: '28px' }}>
              라떼비버(이하 "서비스")는 이용자의 개인정보를 중요하게 생각하며,
              「개인정보 보호법」을 준수합니다. 본 방침은 서비스가 수집하는 개인정보의
              항목, 목적, 보유기간, 파기 방법, 이용자의 권리 등을 안내합니다.
            </p>

            <Section title="1. 수집하는 개인정보 항목 및 수집 방법">
              <p style={{ marginBottom: '12px' }}>서비스는 리포트 생성을 위해 이용자가 직접 입력하는 아래 정보를 수집합니다.</p>
              <table className="lb-table" style={{ marginBottom: '12px' }}>
                <thead>
                  <tr><th>항목</th><th>필수/선택</th><th>수집 목적</th></tr>
                </thead>
                <tbody>
                  <tr><td>이름 또는 닉네임</td><td>필수</td><td>리포트 표시용 식별자</td></tr>
                  <tr><td>현재 나이, 은퇴 목표 나이</td><td>필수</td><td>은퇴 기간 계산</td></tr>
                  <tr><td>목표 월 연금액</td><td>필수</td><td>필요 자산 규모 계산</td></tr>
                  <tr><td>개인연금·퇴직연금(IRP) 적립액</td><td>필수</td><td>현재 자산 기반 시뮬레이션</td></tr>
                  <tr><td>국민연금 예상 수령액</td><td>필수</td><td>공적 연금 반영</td></tr>
                  <tr><td>목표 수익률(적립·인출)</td><td>필수</td><td>수익률 시나리오 계산</td></tr>
                </tbody>
              </table>
              <p className="lb-text-muted lb-text-sm">
                위 정보는 이용자가 직접 폼에 입력하는 방식으로만 수집되며, 자동 수집은 없습니다.
              </p>
            </Section>

            <Section title="2. 개인정보의 수집·이용 목적">
              <ul>
                <li>맞춤형 은퇴 플래닝 리포트 생성 및 URL 조회 제공</li>
                <li>서비스 개선 및 연금 설계 경향 파악을 위한 익명 통계 생성
                  (이름 제외, 개인 식별 불가 형태로만 활용)</li>
              </ul>
            </Section>

            <Section title="3. 개인정보의 보유·이용 기간 및 파기">
              <table className="lb-table" style={{ marginBottom: '12px' }}>
                <thead>
                  <tr><th>구분</th><th>보유 기간</th><th>파기 방법</th></tr>
                </thead>
                <tbody>
                  <tr>
                    <td>원본 입력정보</td>
                    <td>리포트 생성일부터 30일, 또는 이용자 삭제 요청 시</td>
                    <td>데이터베이스에서 즉시 삭제</td>
                  </tr>
                  <tr>
                    <td>익명 집계 통계</td>
                    <td>서비스 운영 기간</td>
                    <td>개인 식별 불가 형태로 별도 보관 (파기 대상 아님)</td>
                  </tr>
                </tbody>
              </table>
              <p className="lb-text-muted lb-text-sm">
                원본 정보는 보유기간 만료 시 데이터베이스에서 자동으로 삭제됩니다.
                삭제 요청은 아래 개인정보 보호책임자에게 문의하시기 바랍니다.
              </p>
            </Section>

            <Section title="4. 개인정보의 제3자 제공">
              <p>서비스는 이용자의 개인정보를 제3자에게 제공하지 않습니다.</p>
            </Section>

            <Section title="5. 개인정보 처리위탁 및 국외 이전">
              <p style={{ marginBottom: '12px' }}>
                서비스 제공을 위해 아래 업체에 개인정보 처리를 위탁합니다.
                위탁업체는 위탁 업무 수행 목적 외 개인정보를 이용하지 않습니다.
              </p>
              <table className="lb-table" style={{ marginBottom: '12px' }}>
                <thead>
                  <tr>
                    <th>수탁자</th>
                    <th>위탁 업무</th>
                    <th>이전 국가</th>
                    <th>보유 기간</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>Google LLC (Firebase / Google Cloud)</td>
                    <td>데이터베이스 저장, 서버 운영, 호스팅</td>
                    <td>미국</td>
                    <td>위탁계약 종료 시 또는 원본 보유기간 만료 시</td>
                  </tr>
                </tbody>
              </table>
              <p className="lb-text-muted lb-text-sm">
                국외 이전에 대해 동의를 원하지 않으시면 서비스 이용이 불가합니다.
                추가 LLM·AI 서비스 연동 시 본 방침을 업데이트하고 재동의를 받습니다.
              </p>
            </Section>

            <Section title="6. 이용자의 권리 및 행사 방법">
              <p>이용자는 아래 권리를 행사할 수 있습니다.</p>
              <ul>
                <li>개인정보 열람 요청</li>
                <li>개인정보 정정·삭제 요청</li>
                <li>개인정보 처리정지 요청</li>
                <li>동의 철회</li>
              </ul>
              <p>
                권리 행사는 아래 개인정보 보호책임자에게 이메일로 요청하시기 바랍니다.
                요청 후 10일 이내에 처리 결과를 안내드립니다.
              </p>
            </Section>

            <Section title="7. 개인정보 자동 수집 장치 (쿠키 등)">
              <p>
                현재 서비스는 별도의 쿠키 또는 행동 분석 도구를 사용하지 않습니다.
                향후 도입 시 본 방침을 업데이트합니다.
              </p>
            </Section>

            <Section title="8. 개인정보 보호책임자">
              <table className="lb-table" style={{ marginBottom: '12px' }}>
                <tbody>
                  <tr><th>성명</th><td>서비스 운영자</td></tr>
                  <tr>
                    <th>이메일</th>
                    <td>
                      <a href="mailto:contact@beaver-pension.com">contact@beaver-pension.com</a>
                    </td>
                  </tr>
                </tbody>
              </table>
              <p className="lb-text-muted lb-text-sm">
                개인정보 침해에 대한 신고·상담은 개인정보보호위원회(privacy.go.kr) 또는
                한국인터넷진흥원 개인정보침해신고센터(118)에 문의하실 수 있습니다.
              </p>
            </Section>

            <div style={{ marginTop: '28px', paddingTop: '20px', borderTop: '1px solid var(--color-border-light)', textAlign: 'center' }}>
              <a href="/" className="lb-btn lb-btn-outline">
                ← 입력 페이지로 돌아가기
              </a>
            </div>

            </div>
          </div>
        </div>
      </ReportAdLayout>
    </div>
  );
}

function Section({ title, children }) {
  return (
    <div style={{ marginBottom: '28px' }}>
      <h2
        style={{
          fontSize: '16px',
          fontWeight: 800,
          color: 'var(--color-brown-900)',
          borderBottom: '1px solid var(--color-border-light)',
          paddingBottom: '6px',
          marginBottom: '12px',
        }}
      >
        {title}
      </h2>
      {children}
    </div>
  );
}
